import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SignalRService } from "./signalr-service/signalr.service";

@NgModule({
    imports: [CommonModule],
    providers: [SignalRService],
    exports: [],
})
export class RealTimeNotificationsModule {}
